import React, { useEffect, useRef, useState } from "react";
import { Div } from "components/Base";
import Field from "./Field";
import { debounce } from "utils/General";
import Helpers from "utils/Global/Helpers";

const CONTAINER_STYLE = {
  position: "relative",
  borderBottom: "1px dashed #ccc",
  marginBottom: "16px"
};

const ROW_STYLE = { gap: "16px" };

const REMOVE_STYLE = {
  position: "absolute",
  right: 0,
  top: 0,
  cursor: "pointer",
  fontSize: "18px",
  "&:hover": {
    opacity: 0.8
  }
};

const AdditionalContact = ({
  updateSpeakerAdditionalContact,
  removeSpeakerAdditionalContact,
  contact,
  contactIndex,
  selectedSpeakerId,
  generalError = false
}) => {
  const updateField = ({ id, value: { value } }) => {
    const contactValues = { ...contact, [id.split("-").shift()]: value };
    updateSpeakerAdditionalContact({
      selectedSpeakerId,
      contactIndex,
      contactValues
    });
  };
  const [validateFirstName, setValidateFirstName] = useState(false);
  const [validateLastName, setValidateLastName] = useState(false);
  const [validateEmail, setValidateEmail] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else if (generalError) {
      setValidateFirstName(true);
      setValidateLastName(true);
      setValidateEmail(true);
    }
  }, [generalError]);

  return (
    <Div width={1} style={CONTAINER_STYLE}>
      <i
        onClick={debounce(
          () =>
            removeSpeakerAdditionalContact({ selectedSpeakerId, contactIndex }),
          100
        )}
        className="material-icons"
        style={REMOVE_STYLE}
        title="Remove secondary contact"
      >
        close
      </i>
      <Div
        width={1}
        mb={1}
        display="flex.space-between.flex-start"
        style={ROW_STYLE}
      >
        <Div width={1} display="column.flex-start.stretch">
          <Field
            onBlur={() => {
              if (!validateLastName) setValidateFirstName(true);
            }}
            field={{
              id: `firstName-${selectedSpeakerId}-${contactIndex}`,
              type: "text",
              required: true,
              name: "First name",
              isValid: !validateFirstName ? true : contact.firstName.length > 0
            }}
            isSecondaryContactField
            values={{
              [`firstName-${selectedSpeakerId}-${contactIndex}`]: {
                value: contact.firstName
              }
            }}
            updateValues={updateField}
          />
        </Div>
        <Div width={1} display="column.flex-start.stretch">
          <Field
            onBlur={() => {
              if (!validateLastName) setValidateLastName(true);
            }}
            field={{
              id: `lastName-${selectedSpeakerId}-${contactIndex}`,
              type: "text",
              required: true,
              name: "Last name",
              isValid: !validateLastName ? true : contact.lastName.length > 0
            }}
            isSecondaryContactField
            values={{
              [`lastName-${selectedSpeakerId}-${contactIndex}`]: {
                value: contact.lastName
              }
            }}
            updateValues={updateField}
          />
        </Div>
      </Div>
      <Div
        width={1}
        mb={2}
        display="flex.space-between.flex-start"
        style={ROW_STYLE}
      >
        <Div width={1} display="column.flex-start.stretch">
          <Field
            onBlur={() => {
              if (!validateEmail) setValidateEmail(true);
            }}
            field={{
              id: `email-${selectedSpeakerId}-${contactIndex}`,
              type: "email",
              required: true,
              name: "Email",
              isValid: true
            }}
            isSecondaryContactField
            emailError={
              !validateEmail
                ? ""
                : !Helpers.isValidEmail(contact.email)
                ? "This is not a valid email"
                : ""
            }
            values={{
              [`email-${selectedSpeakerId}-${contactIndex}`]: {
                value: contact.email
              }
            }}
            updateValues={updateField}
          />
        </Div>
        <Div width={1} display="column.flex-start.stretch">
          <Field
            field={{
              id: `role-${selectedSpeakerId}-${contactIndex}`,
              type: "text",
              required: false,
              name: "Role",
              isValid: true
            }}
            isSecondaryContactField
            values={{
              [`role-${selectedSpeakerId}-${contactIndex}`]: {
                value: contact.role
              }
            }}
            updateValues={updateField}
          />
        </Div>
      </Div>
    </Div>
  );
};

export default AdditionalContact;
